<div *ngIf="auth.authenticated && auth?.user?.referenceAutomationExceptionsAccess;else other_content;">

  <h2>Reference Exceptions</h2>
  <br />
  <p *ngIf="!allReferenceAutomationExceptions"><em>Loading...</em></p>

  <div *ngIf="allReferenceAutomationExceptions" class=" ">
    <table class='table'>
      <thead>
        <tr>
          <th style="text-align: center">Index</th>
          <th style="text-align: center">Account Number</th>
          <th style="text-align: center">Defi App ID</th>
          <th style="text-align: center">Reference Number</th>
          <th style="text-align: center">Additional Notes</th>
          <th style="text-align: center">Done?</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let referenceAutomationExceptions of allReferenceAutomationExceptions; let isOdd=odd; let i=index;">
          <tr [class.odd]="isOdd">
            <td style="text-align: center">
              {{ i + 1 }}
            </td>

            <ng-container *ngIf="referenceAutomationExceptions.accountNumber != 'NULL';else no_accountNumber;">
              <td style="text-align: center">
                <button type="button" class="btn btn-default" (click)='popScreen(referenceAutomationExceptions)'>{{ referenceAutomationExceptions.accountNumber }}</button>
              </td>
            </ng-container>
            <ng-template #no_accountNumber>
              <td style="text-align: center">
                Account Number not available
              </td>
            </ng-template>

            <td style="text-align: center">
              {{ referenceAutomationExceptions.defiAppID }}
            </td>
            <td style="text-align: center">
              {{ referenceAutomationExceptions.referenceNumber }}
            </td>
            <td style="text-align: center">
              {{ referenceAutomationExceptions.additionalNotes }}
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-success" (click)='updateDatabase(referenceAutomationExceptions)'>Done</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #other_content>
  <div *ngIf="!auth.authenticated; else unauthorized;">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div class="exceptions">
      <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
    </div>

    <br />
    <br />
    <br />
    <br />

    <div class="exceptions">
      <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
    </div>

  </div>
  <ng-template #unauthorized>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
  </ng-template>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/reference-automation-exceptions/reference-automation-exceptions.component.html